import { isFeatureEnabled } from 'owa-feature-flags';

export default function isGdprTcfV3FlightEnabled() {
    let gdprTcfV3FlightEnabled: boolean;

    if (isFeatureEnabled('fwk-gdprAdsV3-freString6')) {
        gdprTcfV3FlightEnabled = true;
    }

    return gdprTcfV3FlightEnabled;
}
